








import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
    delete2(){
        this.current.delete()
    }
    public_click2 (data:any) {
        data.item.click()
    }
}
